module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAANlBMVEUAAAB0j/t1kPp1kPp1j/p1kfp2j/x2kfl1kfp1kfl4j/9wj/91kPp1kfl2kPp2kPl1kfp2kfruFzO5AAAAEXRSTlMAQL+fYM9QgMDgIBDvsPCvkBY4xIkAAACnSURBVDjL1dLRDsIgDIXhYmk32Jie939ZYyeEmxWjWdT/pmnyXRBSOjVdQ78GxAM4Y+rXCfO7cGGBk/DydCsGrbtkiIZHAg5dDLGpCWwwQf03KpJNIJAVoT1UxPpPaPCgH4JycZMKh/0/vMlrMJL6sDm6+rA5hgPL1DkPZorNuZCJYnUuNGnOgU2aG0JwdSMIka8fxQdQxk4M5m3ktky7LMljqWQ6ozsuPTuv4R0YbgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/index/images/appIcon/daka_active.png
// module id = RcOA
// module chunks = 57